import { render } from "./BackupPage.vue?vue&type=template&id=19955692&scoped=true"
import script from "./BackupPage.vue?vue&type=script&lang=js"
export * from "./BackupPage.vue?vue&type=script&lang=js"

import "./BackupPage.vue?vue&type=style&index=0&id=19955692&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dell\\Documents\\eChook\\Code\\gpt-nano-configurator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19955692"]])

export default __exports__